<template>
  <div class="custom-page f-w f-h" style="background:white;">
    <h1 class="basic-blue-title">
      <EditableLabel v-model="title" :disabled="!isTitleEditable || !macroEditMode" :placeholder="titlePlaceholder" @input="save" />
    </h1>
    <div style="height:calc(100% - 60px);">
      <!-- PICTURES -->
      <div class="picts-section f-w nw" v-show="showPictures" style="position:relative;padding: 20px;box-sizing: border-box;" :style="psStyle">
        <div class="top-left-btns" v-show="!editingPictures" @click="editPictures" v-if="macroEditMode">
          <img src="/images/edit.png" alt="" />
          <div>{{ $t("message.EDIT") }}</div>
        </div>
        <div class="top-left-btns" v-show="editingPictures" @click="save">
          <img src="/images/ok.png" alt=""/>
          <div>{{ $t("message.SAVE") }}</div>
        </div>
        <div class="pictures" v-show="!editingPictures">
          <div v-for="(pict, index) in pictures" class="edit-img-wrapper">
            <img :src="pict.data" alt="" style="max-width:100%;display:block;" />
          </div>
        </div>
        <div class="f-h edit-pictures-container" v-show="editingPictures">
          <div>
            <div class="legend">{{ $t("message.PICTURES_FROM_PROBLEMS") }}</div>
            <div class="content-wrapper">
              <problem-image-item v-for="problem in problems" :key="problem.id" :problem="problem" @pictureClick="addPictureFromProblem"></problem-image-item>
            </div>
          </div>
          <div class="current">
            <div class="legend">{{ $t("message.CURRENT_PICTURES") }}<button class="action-btn small" @click="$refs.picturesEditor.show()">{{ $t("message.FROM_DEVICE") }}</button></div>
            <div class="content-wrapper">
              <div v-for="(pict, index) in pictures" class="edit-img-wrapper">
                <img class="remove" src="/images/close-white.png" @click="removePicture(index)"/>
                <img :src="pict.data" alt="" style="max-width:100%;display:block;" />
              </div>
            </div>
          </div>
          <div>
            <div class="legend">{{ $t("message.PICTURES_FROM_SLEAN") }}</div>
              <div class="content-wrapper">
              <img v-for="pict in picturesFromSlean" alt="" style="max-width:50%" />
            </div>
          </div>
        </div>
      </div>
      <!-- TEXTS -->
      <div class="f-w" v-show="showTexts" style="position:relative" :style="tsStyle">
        <div @click="editText" v-show="!editingTexts" class="top-left-btns" v-if="macroEditMode">
          <img src="/images/edit.png" alt="" />
          <div>{{ $t("message.EDIT") }}</div>
        </div>
        <div class="top-left-btns" v-show="editingTexts" @click="save">
          <img src="/images/ok.png" alt=""/>
          <div>{{ $t("message.SAVE") }}</div>
        </div>
        <div class="safety-texts-wrapper">
          <div>
            <div class="legend" v-show="editingTexts">{{ textEditionLegend }}</div>
            <textarea v-model="text" v-if="editingTexts" :placeholder="textPlaceholder"></textarea>
            <div v-else>{{ text }}</div>
          </div>
        </div>
      </div>
    </div>
    <pictures-editor ref="picturesEditor" @editionDone="picturesEditionDone"></pictures-editor>
  </div>
</template>

<script>
/** Entire page customizable by the user
@param id: id of the custom page entry in the DB
@Param fixTitle: if set, the title won't be editable */

import EditableLabel from '@/components/editable-label.vue';
import PicturesEditor from '@/components/pictures-editor.vue';
import ProblemImageItem from '@/components/problem-image-item.vue';

export default {
  name: 'CustomPage',
  components: {
    EditableLabel,
    'pictures-editor': PicturesEditor,
    'problem-image-item': ProblemImageItem
  },
  props: ['id', 'fixTitle'],
  data: function() {
    return {
      picturesEditorRef: "picturesEditorRef",
      editingPictures: false,
      editingTexts: false,
      pictures: [],
      problems: [],
      picturesFromSlean: [],
      title: "",
      text: "",
      textEditionLegend: "",
      textEditionLegendReplace: this.$t("message.CLICK_TO_EDIT"),
    }
  },
  beforeRouteEnter: function(to, from, next) {
    next(function(comp) {
      comp.refresh();
    });
  },
  computed: {
    macroEditMode: function() {
      return !this.$store.state.meeting.isMeetingInProgress;
    },
    textPlaceholder: function() {
      return this.macroEditMode ? this.$t("message.CUSTOM_TEXT_PH") : "";
    },
    /** Show top section */
    showPictures: function() {
      return this.macroEditMode || this.pictures.length;
    },
    /** Show bottom section */
    showTexts: function() {
      return this.macroEditMode || this.text.length;
    },
    /** Pictures section style */
    psStyle: function() {
      return this.showTexts ? "height: 65%" : "height: 100%";
    },
    /** Texts section style */
    tsStyle: function() {
      return this.showPictures ? "height: 35%" : "height: 100%";
    },
    /** Is title editable */
    isTitleEditable: function() {
      return typeof this.fixTitle == "undefined";
    },
    /** Title placeholder when necesary */
    titlePlaceholder: function() {
      return this.macroEditMode ? this.$t("message.CUSTOM_TEXT_PH") : '';
    }
  },
  methods: {
    refresh: function() {
      var self = this;
      if (typeof this.fixTitle != "undefined") {
        this.title = this.fixTitle;
      }
      self.App.post("/server/teams/getCustomPage.php", {id: this.id}, function(d) {
        if (d && typeof d == "object") {
          self.title = self.isTitleEditable ? d.title : self.fixTitle;
          self.pictures = d.pictures;
          self.text = d.text;
        }
      });
    },
    save: function() {
      var self = this;
      this.App.post("/server/teams/setCustomPage.php", {id: this.id, title: this.title, pictures: this.pictures, text: this.text}, function(d) {
        if (d == "1") {
          self.editingPictures = false;
          self.editingTexts = false;
          self.textEditionLegend = "";
        }
      });
    },
    addPictureFromProblem: function(data) {
      this.pictures.push(data);
    },
    removePicture: function(index) {
      this.pictures.splice(index, 1);
    },
    editPictures: function() {
      this.editingPictures = true;
      var self = this;
      self.$parent.post("/server/problems/get.php", {all: true}, function(d) {
        self.problems = d.problems;
      });
    },
    /** Back from pictures editor */
    picturesEditionDone: function() {
      this.pictures = this.pictures.concat(this.$refs.picturesEditor.pictures);
      this.$refs.picturesEditor.pictures = [];
    },
    editText: function() {
      this.editingTexts = true;
      this.textEditionLegend = this.textEditionLegendReplace;
    }
  }
};
</script>
